import mapboxStatic from '@mapbox/mapbox-sdk/services/static';

const MAPBOX_API_KEY = 'pk.eyJ1IjoiaW5lZmZ5YmxlIiwiYSI6ImNqdW90OTJkYTBqeW00ZXBpOXg0cmZzdHEifQ.G5fzVIE-uV878X9eKZJp5A';

export const Mapbox = mapboxStatic({ accessToken: MAPBOX_API_KEY });
